import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const GET_PDF_VIEW_REQUEST = 'GET_PDF_VIEW_REQUEST';
export const GET_PDF_VIEW_SUCCESS = 'GET_PDF_VIEW_SUCCESS';
export const GET_PDF_VIEW_FAILURE = 'GET_PDF_VIEW_FAILURE';

function requestGetPdfView() {
  return {
    type: GET_PDF_VIEW_REQUEST,
    isFetchingPdfView: true
  };
}

function receiveGetPdfView(pdfFile) {
  return {
    type: GET_PDF_VIEW_SUCCESS,
    isFetchingPdfView: false,
    pdfFile,
    getPdfViewError: null
  };
}

function rejectGetPdfView(getPdfViewError) {
  return {
    type: GET_PDF_VIEW_FAILURE,
    isFetchingPdfView: false,
    viewPdfData: null,
    getPdfViewError
  };
}

export function getPdfView(file) {
  return (dispatch) => {
    dispatch(requestGetPdfView());

    const promise = () => ApiService
      .getPdfView(file, { responseType: 'arraybuffer' })
      .then((response) => {
        file.blob = response.data;
        dispatch(receiveGetPdfView(file));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response) {
          const status = error.response && error.response.status;
          if (status !== 401) {
            dispatch(handleException(error, rejectGetPdfView, !status || (status !== 404 && status !== 401)));
          }
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, rejectGetPdfView, false));
        }
      });
    return promise();
  };
}
